export default __webpack_public_path__ + "static/media/bubble-03.63a7df76.jpg";